import { ChangeDetectionStrategy, Component, ElementRef, forwardRef, ViewChild } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'lin-form-file-input',
  template: ` <input #fileInput type="file" (change)="onFileChange($event.target)" /> `,
  styles: [
    `
      :host {
        position: absolute;
        visibility: hidden;
      }
    `,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FileInputComponent implements ControlValueAccessor {
  onChange: Function

  file: File | null = null

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>

  openSelectDialog() {
    this.fileInput.nativeElement.click()
  }

  onFileChange(target: EventTarget) {
    const fileInput = <HTMLInputElement>target
    const { files } = fileInput
    const file = files[0] || null

    this.file = file
    this.onChange(file)
  }

  writeValue(value: null) {
    this.fileInput.nativeElement.value = ''
    this.file = null
  }

  registerOnChange(fn: Function) {
    this.onChange = fn
  }

  registerOnTouched(fn: Function) {}
}
